import { createReducer, on, Action } from '@ngrx/store';
import { Role } from '@models';
import * as RoleActions from '@role/store/role.actions';

export const roleFeatureKey = 'role';

export enum errorTypes {
  fetching = 'fetching',
  creating = 'creating',
  editing = 'editing',
  deleting = 'deleting',
}

export interface RoleState {
  collection: Role[];
  row: Role;
  error: Error;
  errorType: errorTypes;

  isFetching: boolean;
  hasError: boolean;
  successfullyAdded: boolean;
  successfullyEdited: boolean;
  successfullyDeleted: boolean;
}

export const initialState: RoleState = {
  collection: [],
  row: null,
  error: null,
  errorType: null,

  isFetching: false,
  hasError: false,
  successfullyAdded: false,
  successfullyEdited: false,
  successfullyDeleted: false,
};

const roleReducer = createReducer(
  initialState,
  on(RoleActions.GetList, state => (
    Object.assign({}, state, {
      collection: [],
      isFetching: true,
    })
  )),
  on(
    RoleActions.GetList,
    (state) => {
      const auxRow = Object.assign({}, state.row, {views: []});
      return Object.assign({}, state, {
        isFetching: true,
        collection: [],
        row: auxRow,
      });
  }),
  on(RoleActions.GetListSuccess, (state, payload) => {
    // const newRow = Object.assign({}, state.row, {: payload.views});
    return Object.assign({}, state, {
      collection: payload.data,
      isFetching: false,
      // row: newRow,
    });
  }),
);

export function reducer(state: RoleState | undefined, action: Action) {
  return roleReducer(state, action);
}

// export function RoleReducer(state = initialState, action: ActionEx) {
//   let newState = state;

//   switch (action.type) {
//     case RoleActionTypes.Add:
//       // return [...state, action.payload];
//       return state;

//     case RoleActionTypes.Remove:
//       // return [
//       //   ...state.slice(0, action.payload),
//       //   ...state.slice(action.payload + 1)
//       // ];
//       return state;

//     case RoleActionTypes.GetList:
//       newState = Object.assign(
//         {}, state, {data: action.payload, pending: true, }
//       );
//       return newState;
//       // return [...state, action.payload];

//       case RoleActionTypes.GetListSuccess:
//         newState = Object.assign(
//           {}, state, {data: action.payload, pending: false, }
//         );
//         return newState;

//     default:
//       return state;
//   }
// }
